import React from 'react'
import './resources/Sponsor.css'
import { SponsorProps } from './types/SponsorProps'

export const Sponsor: React.FunctionComponent<SponsorProps> = ({ sponsor }: SponsorProps) => (
  <div className='sponsor'>
    <img alt={sponsor.name} src={`/sponsors/${sponsor.sponsor_id}.jpg`} />
  </div>
)
